<template>
  <div class="list-group-item  border-left border-right position-relative">
    <div>
      <div class="position-absolute" style="left:15px;top:10px;">
        <i v-if="item.isPrescribed" class="fas fa-check-square mr-3" @click="setPrescribed(false)"></i>
        <i v-else class="far fa-square mr-3" @click="setPrescribed(true)"></i>
      </div>

      <div style="margin-left:20px;" @click="details = !details">
        <div v-if="item.updating" class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>

        {{item.title}}

        <div class="position-absolute" style="right:5px;top:12px;">
          <i :class="'fas mr-3 fa-chevron-' + (details ? 'up' : 'down')"></i>
        </div>
      </div>
    </div>

    <ul v-if="details" class="mt-3">
      <li
          v-for="(field, filedKey) in item.fields"
          :key="filedKey">
        <small :class="'checkup-label checkup-strength-' + field.strength">
          {{field.level}}
        </small>

        {{field.label}}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'CheckupItem',

    props: ['item', 'updatePrescription'],

    data() {
      return {
        details: false,
      };
    },

    computed: {},

    methods: {
      async setPrescribed(state) {
        await this.updatePrescription(this.item.id, state);
      },
    },
  };
</script>

<style lang="scss">
  .checkup-label {
    display: inline-block;
    width: 20px;
    padding: 2px 0;
    text-align: center;
    font-weight: bold;
    color: #000;
    background-color: #ccc;
    border-radius: 5px;
  }
</style>
